/**
 * Comprueba que value sea distinto de undefined, null o false. Si es así se devuelve back, que por defecto es una cadena vacía.
 * @param {mixed} value
 * @param {mixed} back
 */

export const isDev = !process.env.NODE_ENV || process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test';

export const nonUndefined = (value, back = '') => value === undefined || !value ? back : value
